// extracted by mini-css-extract-plugin
export default {"root":"GracePeriodDate_root__Nvbgw"};